import type { JSX } from "react";

import { Center, Flex, Stack, Text } from "@mantine/core";

import { LightBulbIcon } from "../../Icons";

export function StringExamplesList({ examples }: { examples: string[] }): JSX.Element | null {
    if (examples.length === 0) return null;

    return (
        <Stack gap="xxs">
            {examples.map((text, i) => (
                <Flex key={`${i}-${text}`} p="xxs" bg="#333f4880">
                    <Center p="0.25rem 0.5rem 0.5rem 0rem">
                        <LightBulbIcon />
                    </Center>
                    <Text size="12px" lh="sm">
                        {text}
                    </Text>
                </Flex>
            ))}
        </Stack>
    );
}
